import type { ComponentProps } from 'react'

import { t } from 'i18next'
import { Link } from 'react-router'

import { Icon } from '@/components/icon'
import { cn } from '@/infra'
import { StringUtils } from '@/utils'

const ResumoDocumentos = ({ className, ...props }: ComponentProps<typeof Link>) => {
  return (
    <Link
      className={cn(
        `hover:bg-muted/50 flex w-full content-start items-center justify-between px-4 py-4 transition-colors`,
        className,
      )}
      {...props}
    />
  )
}

const ResumoDocumentosContent = ({ children, ...props }: ComponentProps<'div'>) => {
  return (
    <>
      <div className="flex-1 items-start justify-items-start space-y-1 text-neutral-800" {...props}>
        {children}
      </div>
      <Icon name="chevron-right" className="h-7 w-7 text-neutral-800" />
    </>
  )
}

const ResumoDocumentosInfo = ({
  titulo,
  descricoes,
  quantidade,
}: {
  titulo: string
  descricoes: string | string[]
  quantidade: number
}) => {
  return (
    <>
      <h3 className="font-semibold capitalize">{titulo}</h3>
      {Array.isArray(descricoes) ? (
        descricoes.map((descricao) => (
          <p key={descricao} className="text-sm">
            {descricao}
          </p>
        ))
      ) : (
        <p className="text-sm">{descricoes}</p>
      )}
      <p className={`mt-3 text-sm ${quantidade ? 'text-green-800' : 'text-red-600'}`}>
        {quantidade ? (
          <span>
            {`${quantidade} `}
            {StringUtils.singularPlural(quantidade, t('common:documentos.anexado'), t('common:documentos.anexados'))}
          </span>
        ) : (
          <span>{t('common:documentos.nenhum')}</span>
        )}
      </p>
    </>
  )
}

export { ResumoDocumentos, ResumoDocumentosContent, ResumoDocumentosInfo }
